import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowDiagonalLeftDownOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M11.5 13.5h-9v-9h1.4v6.609L12.5 2.5l1 1-8.61 8.6h6.61z" fill="currentColor" />
            </g>
        </svg>
    )
);
ArrowDiagonalLeftDownOutlinedSize16Glyph.displayName = 'ArrowDiagonalLeftDownOutlinedSize16Glyph';
